import React from 'react';
import { FaRobot } from 'react-icons/fa';

const TypingIndicator = ({ variant = 'default' }) => {
  const renderDots = () => {
    if (variant === 'glow') {
      return (
        <div className="flex items-center space-x-1">
          <div className="modern-typing-dot-glow"></div>
          <div className="modern-typing-dot-glow"></div>
          <div className="modern-typing-dot-glow"></div>
        </div>
      );
    }
    
    return (
      <div className="flex items-center space-x-1">
        <div className="modern-typing-dot"></div>
        <div className="modern-typing-dot"></div>
        <div className="modern-typing-dot"></div>
      </div>
    );
  };

  return (
    <div className="flex justify-start">
      <div className="flex items-start space-x-2">
        <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center">
          <FaRobot />
        </div>
        <div className="bg-gray-100 text-gray-800 px-4 py-3 rounded-lg shadow-sm">
          <div className="modern-typing-indicator">
            <span className="text-sm text-gray-600 mr-2"></span>
            {renderDots()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
